/**
 * SDK types - Auto-generated.
 * @generated
 */

export interface SDKMethodOptions {
  entity_id?: string;
  account_id?: string;
  signal?: AbortSignal;
}

export interface SDKListOptions extends SDKMethodOptions {
  limit?: number;
  next_cursor?: string;
  prev_cursor?: string;
  include_total_count?: boolean;
  order_by?: string;
  query?: string;
  search?: string;
  include?: string;
}

export interface SDKConfig {
  accessToken: string | (() => string | Promise<string>);
  basePath?: string;
  clientName?: string;
  onUnauthorized?: (response: Response) => void;
}

export const DEFAULT_BASE_URL = "https://eu.spaceinvoices.com";
